import { createFileRoute, redirect } from "@tanstack/react-router";
import { InventoryCountPrintPage } from "@/features/inventory-count/pages/InventoryCountPrintPage";

export const Route = createFileRoute("/admin/inventory-count/$id/print")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_count.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountPrintPage,
});
